import IconTemplate from '@components/Icon';
import { rem } from 'polished';
import styled from 'styled-components';
import { DESKTOP_HEADER_HEIGHT, MOBILE_HEADER_HEIGHT } from '../../constants';
import { breakpoints } from '../../styles/theme';

export const Wrapper = styled.div`
    display: flex;
    padding: ${rem(45)} ${rem(20)};
    max-width: ${rem(1180)};
    margin: ${rem(MOBILE_HEADER_HEIGHT)} auto 0 auto;
    min-height: ${rem(500)};
    flex-direction: column-reverse;

    @media (min-width: ${breakpoints.sm}px) {
        margin: ${rem(DESKTOP_HEADER_HEIGHT)} auto 0 auto;
    }

    @media (min-width: ${breakpoints.md}px) {
        flex-direction: row;
        align-items: center;
        padding: 0;
    }
`;

export const Image = styled.img`
    width: 100%;
    border-radius: ${rem(24)};
    height: auto;
    margin-top: ${rem(40)};

    @media (min-width: ${breakpoints.md}px) {
        display: block;
        margin-top: ${rem(0)};
        width: ${rem(600)};
    }
`;

export const Title = styled.h1`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-size: ${({ theme }) => theme.fontSizes.h3};
    font-family: ${({ theme }) => theme.fonts.fontSecondary};
    padding-bottom: ${rem(30)};

    @media (min-width: ${breakpoints.md}px) {
        font-size: ${({ theme }) => theme.fontSizes.h2};
    }
`;

export const Item = styled.div`
    display: flex;
    padding: ${rem(20)} 0;
`;

export const Contacts = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;

    @media (min-width: ${breakpoints.md}px) {
        padding-left: ${rem(50)};
    }
`;

export const Icon = styled(IconTemplate)`
    padding-right: ${rem(20)};

    svg {
        width: ${rem(35)};
        height: ${rem(35)};
    }
`;

export const Contact = styled.div`
    display: flex;
    flex-direction: column;
    font-size: ${({ theme }) => theme.fontSizes.h6};
`;

export const ContactTitle = styled.span`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    padding-bottom: ${rem(5)};
`;

export const ContactLinks = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: ${rem(8)};
    gap: ${rem(10)};

    @media (min-width: ${breakpoints.md}px) {
        flex-direction: row;
        align-items: center;
    }
`;

export const ContactLink = styled.a`
    cursor: pointer;
    text-decoration: none;
    color: ${({ theme }) => theme.colors.primary};
`;

export const ContactLinkDivider = styled.div`
    height: ${rem(14)};
    width: ${rem(1)};
    background: ${({ theme }) => theme.colors.grey};
    margin: 0 ${rem(10)};
    display: none;

    @media (min-width: ${breakpoints.md}px) {
        display: block;
    }
`;
